import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "button"]

  connect() {
    this.originalButtonText = this.buttonTarget.textContent
  }

  disconnect() {
    clearTimeout(this.resetTimeout)
  }

  async copy() {
    try {
      await navigator.clipboard.writeText(this.sourceTarget.value)
      this.showCopied()
    } catch (_error) {
      this.copyWithSelection()
    }
  }

  copyWithSelection() {
    this.sourceTarget.select()
    const copied = document.execCommand("copy")
    this.sourceTarget.setSelectionRange(0, 0)
    this.buttonTarget.focus()

    if (copied) this.showCopied()
  }

  showCopied() {
    clearTimeout(this.resetTimeout)
    this.buttonTarget.textContent = "✓ Copied"
    this.resetTimeout = setTimeout(() => {
      this.buttonTarget.textContent = this.originalButtonText
    }, 2000)
  }
}
